export const futbolIcon = require('./futbol-icon.svg');